import React, { useState, useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { LoginLayout, Input, Button, Toast } from "@app/components";
import { FormFlexWrapper } from "@app/components/commonStyles";
import { emailPattern, useLocation } from "@app/utils";
import { forgotPassword } from "@app/services";
import { AuthContext } from "@app/providers";
import {
  ButtonContainer,
  ForgotPwdContentWrapper,
  ForgotPwdImage,
  ForgotPwdMessage,
  SignInContainer,
} from "./forgot-password-component";
import { Support_v2 } from "@app/assets";

export default function ForgotPassword() {
  const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });
  const { navigate } = useLocation();
  const [buttonText, setButtonText] = useState<string>("Submit");
  const [showToast, setShowToast] = useState(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  async function onSubmit(data: any) {
    const params: any = {};
    Object.assign(params, {
      email: data.email,
    });
    setButtonText("Submitting...");
    forgotPassword(params)
      .then((res: any) => {
        setButtonText("Submit");
        if (res._responseStatus) {
          setShowSuccess(true);
        } else {
          setToastMessage({
            type: "error",
            message: res.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonText("Submit");
        setToastMessage({
          type: "error",
          message: "Something went wrong, Please try again.",
        });
        setShowToast(true);
      });
  }
  function Forgotpass() {
    navigate('/sign-in')
  }
  const { userInfo } = useContext(AuthContext);
  const [loginUserinfo, setLoginUserinfo] = useState('')
  useEffect(() => {
    let data: any = localStorage.getItem('paymentUser') || "";
    if (data) {
      data = JSON.parse(data);
      setLoginUserinfo(data.userType === "parent" ? "Parent" : "Educator");
    }
  }, [])

  if (!showSuccess) {
    return (
      <>
        <LoginLayout path="" label="">
          <SignInContainer>
            <form onSubmit={handleSubmit(onSubmit)} className="w-100">
              <h3 className="primary-header text-center mb-3">
                Forgot Password
              </h3>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Input
                    label="Enter the Email address associated with your account"
                    type="email"
                    placeholder="Enter Email Address"
                    name="email"
                    register={register({
                      required: true,
                      pattern: emailPattern,
                    })}
                    error={
                      (errors.email &&
                        errors.email.type === "required" &&
                        "Please enter Email Address") ||
                      (errors.email &&
                        errors.email.type === "pattern" &&
                        "Please enter valid Email Address")
                    }
                  // autoFocus={true}
                  />
                </div>
              </FormFlexWrapper>
              <ButtonContainer disabled={buttonText === "Submitting..."}>
                <Button
                  variant="newsecondary"
                  size="large"
                  width="100%"
                  type="submit"
                >
                  {buttonText}
                </Button>
              </ButtonContainer>
              <ButtonContainer style={{ marginTop: "15px" }}>
                <Button onClick={() => Forgotpass()}
                  variant="bordered"
                  size="large"
                  width='100%'>
                  Cancel
              </Button>
              </ButtonContainer>
            </form>
          </SignInContainer>
          <Toast
            message={toastMessage.message}
            showToast={showToast}
            type={toastMessage.type}
            onClose={() => setShowToast(false)}
          />
        </LoginLayout>
      </>
    );
  } else {
    return (
      <LoginLayout path="" label="" forgotPassword={true}>
        <ForgotPwdImage src={Support_v2} />
        <ForgotPwdContentWrapper>
          <h3 className="primary-header text-center">Forgot Password</h3>
          <ForgotPwdMessage>
            Please check your email and click on the link provided to reset your
            password
          </ForgotPwdMessage>
          <Button
            variant="newsecondary"
            type="button"
            onClick={() => navigate("/")}
          >
            Sign In
          </Button>
        </ForgotPwdContentWrapper>
      </LoginLayout>
    );
  }
}
